import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-export-icon",
  "use": "icon-export-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-export-icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 384V154.453333L477.696 636.928l-90.453333-90.538667L869.546667 64H640V0H1024v384h-64zM512 64H64v896h896V512H1024v512H0V0h512v64z\" p-id=\"1679\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol